module.exports = __webpack_public_path__ + "img/sexual.b05a5d56.svg";